/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.js to modify the generation of this file.

import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-react';

import NutritionLabelTable from '../components/NutritionLabelTable';
import TestComponent from '../components/TestComponent';
import YoutubePlayer from '../components/YoutubePlayer';
import Accordion from '../components/Accordion/Accordion';
import Accordionstyles from '../components/Accordion/Accordion.styles';
import AccordionSection from '../components/AccordionSection/AccordionSection';
import AccordionSectionstyles from '../components/AccordionSection/AccordionSection.styles';
import AlertRibbon from '../components/AlertRibbon/AlertRibbon';
import AlertRibbonstyles from '../components/AlertRibbon/AlertRibbon.styles';
import ArticleGrid from '../components/ArticleGrid/ArticleGrid';
import ArticleGridstyles from '../components/ArticleGrid/ArticleGrid.styles';
import BeautifulBeanFootageTVSvg from '../components/BeautifulBeanFootageTVSvg/BeautifulBeanFootageTVSvg';
import BeautifulBeanFootageTVSvgstyles from '../components/BeautifulBeanFootageTVSvg/BeautifulBeanFootageTVSvg.styles';
import BlogAccordion from '../components/BlogAccordion/BlogAccordion';
import BlogAccordionstyles from '../components/BlogAccordion/BlogAccordion.styles';
import BlogAccordionSection from '../components/BlogAccordionSection/BlogAccordionSection';
import BlogAccordionSectionstyles from '../components/BlogAccordionSection/BlogAccordionSection.styles';
import BlueyBeanChallenge from '../components/BlueyBeanChallenge/BlueyBeanChallenge';
import BlueyBeanChallengestyles from '../components/BlueyBeanChallenge/BlueyBeanChallenge.styles';
import CallToAction from '../components/CallToAction/CallToAction';
import CallToActionstyles from '../components/CallToAction/CallToAction.styles';
import CenteredTextVideo from '../components/CenteredTextVideo/CenteredTextVideo';
import CenteredTextVideostyles from '../components/CenteredTextVideo/CenteredTextVideo.styles';
import ContactRepForm from '../components/ContactRepForm/ContactRepForm';
import ContactRepFormstyles from '../components/ContactRepForm/ContactRepForm.styles';
import ContactRepHero from '../components/ContactRepHero/ContactRepHero';
import ContactUsForm from '../components/ContactUsForm/ContactUsForm';
import ContactUsFormstyles from '../components/ContactUsForm/ContactUsForm.styles';
import ContactUsHero from '../components/ContactUsHero/ContactUsHero';
import Content from '../components/Content/Content';
import Contentstyles from '../components/Content/Content.styles';
import ContentBlock from '../components/ContentBlock/ContentBlock';
import ContentBlockstyles from '../components/ContentBlock/ContentBlock.styles';
import ContentCard from '../components/ContentCard/ContentCard';
import ContentCardstyles from '../components/ContentCard/ContentCard.styles';
import ContentCardContainer from '../components/ContentCardContainer/ContentCardContainer';
import ContentCardContainerstyles from '../components/ContentCardContainer/ContentCardContainer.styles';
import CookiePolicy from '../components/CookiePolicy/CookiePolicy';
import CookiePolicystyles from '../components/CookiePolicy/CookiePolicy.styles';
import FavoritesGrid from '../components/FavoritesGrid/FavoritesGrid';
import FavoritesGridstyles from '../components/FavoritesGrid/FavoritesGrid.styles';
import FeaturedDetailHero from '../components/FeaturedDetailHero/FeaturedDetailHero';
import FeaturedDetailHerostyles from '../components/FeaturedDetailHero/FeaturedDetailHero.styles';
import ArticlePromo from '../components/FeaturedDetailHero/PromoVariants/Article/ArticlePromo';
import ArticlePromostyles from '../components/FeaturedDetailHero/PromoVariants/Article/ArticlePromo.styles';
import GeneralPromo from '../components/FeaturedDetailHero/PromoVariants/General/GeneralPromo';
import GeneralPromostyles from '../components/FeaturedDetailHero/PromoVariants/General/GeneralPromo.styles';
import RecipePromo from '../components/FeaturedDetailHero/PromoVariants/Recipe/RecipePromo';
import RecipePromostyles from '../components/FeaturedDetailHero/PromoVariants/Recipe/RecipePromo.styles';
import FeaturedDetailHeroWithVideo from '../components/FeaturedDetailHeroWithVideo/FeaturedDetailHeroWithVideo';
import FeaturedDetailHeroWithVideostyles from '../components/FeaturedDetailHeroWithVideo/FeaturedDetailHeroWithVideo.styles';
import FeaturedFacts from '../components/FeaturedFacts/FeaturedFacts';
import FeaturedFactsstyles from '../components/FeaturedFacts/FeaturedFacts.styles';
import FeaturedRecipePromo from '../components/FeaturedRecipePromo/FeaturedRecipePromo';
import FeaturedRecipePromostyles from '../components/FeaturedRecipePromo/FeaturedRecipePromo.styles';
import FindInStoreSearchDestiny from '../components/FindInStoreSearchDestiny/FindInStoreSearchDestiny';
import FindInStoreSearchDestinystyles from '../components/FindInStoreSearchDestiny/FindInStoreSearchDestiny.styles';
import FindNearYou from '../components/FindNearYou/FindNearYou';
import FindNearYoustyles from '../components/FindNearYou/FindNearYou.styles';
import Footer from '../components/Footer/Footer';
import Footerstyles from '../components/Footer/Footer.styles';
import SubscribeLoader from '../components/Footer/SubscribeLoader';
import LinksList from '../components/Footer/LinksList/LinksList';
import HeroCarousel from '../components/HeroCarousel/HeroCarousel';
import HeroCarouselstyles from '../components/HeroCarousel/HeroCarousel.styles';
import HeroCarouselSlide from '../components/HeroCarouselSlide/HeroCarouselSlide';
import HeroCarouselSlidestyles from '../components/HeroCarouselSlide/HeroCarouselSlide.styles';
import HeroWithTextLeft from '../components/HeroWithTextLeft/HeroWithTextLeft';
import HeroWithTextLeftstyles from '../components/HeroWithTextLeft/HeroWithTextLeft.styles';
import clouds from '../components/HeroWithTextLeft/svg/clouds';
import HomepageHeroCarousel from '../components/HomepageHeroCarousel/HomepageHeroCarousel';
import HomepageHeroCarouselstyles from '../components/HomepageHeroCarousel/HomepageHeroCarousel.styles';
import HomepageHeroCarouselSlide from '../components/HomepageHeroCarouselSlide/HomepageHeroCarouselSlide';
import HomepageHeroCarouselSlidestyles from '../components/HomepageHeroCarouselSlide/HomepageHeroCarouselSlide.styles';
import IconButton from '../components/IconButton/IconButton';
import IconButtonstyles from '../components/IconButton/IconButton.styles';
import IconList from '../components/IconList/IconList';
import IconListstyles from '../components/IconList/IconList.styles';
import IconListItem from '../components/IconListItem/IconListItem';
import ImageSlider from '../components/ImageSlider/ImageSlider';
import ImageSliderstyles from '../components/ImageSlider/ImageSlider.styles';
import ImageSliderSlide from '../components/ImageSliderSlide/ImageSliderSlide';
import ImageSliderSlidestyles from '../components/ImageSliderSlide/ImageSliderSlide.styles';
import InRecipeProductsFoodservices from '../components/InRecipeProductsFoodservices/InRecipeProductsFoodservices';
import InRecipeProductsFoodservicesstyles from '../components/InRecipeProductsFoodservices/InRecipeProductsFoodservices.styles';
import InRecipeProductsPromo from '../components/InRecipeProductsPromo/InRecipeProductsPromo';
import InRecipeProductsPromostyles from '../components/InRecipeProductsPromo/InRecipeProductsPromo.styles';
import LandingHero from '../components/LandingHero/LandingHero';
import LandingHerostyles from '../components/LandingHero/LandingHero.styles';
import LazyImage from '../components/LazyImage/LazyImage';
import MainNav from '../components/MainNav/MainNav';
import MainNavstyles from '../components/MainNav/MainNav.styles';
import DesktopNav from '../components/MainNav/Components/DesktopNav/DesktopNav';
import DesktopNavstyles from '../components/MainNav/Components/DesktopNav/DesktopNav.styles';
import FsDesktopNav from '../components/MainNav/Components/FsDesktopNav/FsDesktopNav';
import FsDesktopNavstyles from '../components/MainNav/Components/FsDesktopNav/FsDesktopNav.styles';
import FsHamburger from '../components/MainNav/Components/FsHamburger/FsHamburger';
import FsHamburgerstyles from '../components/MainNav/Components/FsHamburger/FsHamburger.styles';
import FsMainNavAboutUsLink from '../components/MainNav/Components/FsMainNavAboutUsLink/FsMainNavAboutUsLink';
import FsMainNavAboutUsLinkstyles from '../components/MainNav/Components/FsMainNavAboutUsLink/FsMainNavAboutUsLink.styles';
import FsMainNavCardLink from '../components/MainNav/Components/FsMainNavCardLink/FsMainNavCardLink';
import FsMainNavCardLinkstyles from '../components/MainNav/Components/FsMainNavCardLink/FsMainNavCardLink.styles';
import FsMainNavProductLink from '../components/MainNav/Components/FsMainNavProductLink/FsMainNavProductLink';
import FsMainNavProductLinkstyles from '../components/MainNav/Components/FsMainNavProductLink/FsMainNavProductLink.styles';
import FsMobileNav from '../components/MainNav/Components/FsMobileNav/FsMobileNav';
import FsMobileNavstyles from '../components/MainNav/Components/FsMobileNav/FsMobileNav.styles';
import Hamburger from '../components/MainNav/Components/Hamburger/Hamburger';
import Hamburgerstyles from '../components/MainNav/Components/Hamburger/Hamburger.styles';
import MainNavAboutUsLink from '../components/MainNav/Components/MainNavAboutUsLink/MainNavAboutUsLink';
import MainNavAboutUsLinkstyles from '../components/MainNav/Components/MainNavAboutUsLink/MainNavAboutUsLink.styles';
import MainNavProductLink from '../components/MainNav/Components/MainNavProductLink/MainNavProductLink';
import MainNavProductLinkstyles from '../components/MainNav/Components/MainNavProductLink/MainNavProductLink.styles';
import MainNavRibbon from '../components/MainNav/Components/MainNavRibbon/MainNavRibbon';
import MainNavRibbonstyles from '../components/MainNav/Components/MainNavRibbon/MainNavRibbon.styles';
import MainNavRibbonCta from '../components/MainNav/Components/MainNavRibbonCta/MainNavRibbonCta';
import MainNavRibbonCtastyles from '../components/MainNav/Components/MainNavRibbonCta/MainNavRibbonCta.styles';
import MobileNav from '../components/MainNav/Components/MobileNav/MobileNav';
import MobileNavstyles from '../components/MainNav/Components/MobileNav/MobileNav.styles';
import MediaCarousel from '../components/MediaCarousel/MediaCarousel';
import MediaCarouselstyles from '../components/MediaCarousel/MediaCarousel.styles';
import MediaCarouselImageSlide from '../components/MediaCarouselImageSlide/MediaCarouselImageSlide';
import MediaCarouselImageSlidestyles from '../components/MediaCarouselImageSlide/MediaCarouselImageSlide.styles';
import MediaCarouselVideoSlide from '../components/MediaCarouselVideoSlide/MediaCarouselVideoSlide';
import MediaCarouselVideoSlidestyles from '../components/MediaCarouselVideoSlide/MediaCarouselVideoSlide.styles';
import NavLink from '../components/NavLink/NavLink';
import NavLinkstyles from '../components/NavLink/NavLink.styles';
import NotFound from '../components/NotFound/NotFound';
import NotFoundstyles from '../components/NotFound/NotFound.styles';
import OffsetFeaturePromo from '../components/OffsetFeaturePromo/OffsetFeaturePromo';
import OffsetFeaturePromostyles from '../components/OffsetFeaturePromo/OffsetFeaturePromo.styles';
import OverTheTopSurveyEmbed from '../components/OverTheTopSurveyEmbed/OverTheTopSurveyEmbed';
import OverTheTopSurveyEmbedstyles from '../components/OverTheTopSurveyEmbed/OverTheTopSurveyEmbed.styles';
import ProductCTA from '../components/ProductCTA/ProductCTA';
import ProductCTAstyles from '../components/ProductCTA/ProductCTA.styles';
import ProductDescription from '../components/ProductDescription/ProductDescription';
import ProductDescriptionstyles from '../components/ProductDescription/ProductDescription.styles';
import ProductDetailHero from '../components/ProductDetailHero/ProductDetailHero';
import ProductDetailHerostyles from '../components/ProductDetailHero/ProductDetailHero.styles';
import ProductGrid from '../components/ProductGrid/ProductGrid';
import ProductGridstyles from '../components/ProductGrid/ProductGrid.styles';
import ProductIngredientBenefitsPromoconfig from '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo.config';
import ProductIngredientBenefitsPromo from '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo';
import ProductIngredientBenefitsPromostyles from '../components/ProductIngredientBenefitsPromo/ProductIngredientBenefitsPromo.styles';
import ProductListCarousel from '../components/ProductListCarousel/ProductListCarousel';
import ProductListCarouselstyles from '../components/ProductListCarousel/ProductListCarousel.styles';
import ProductNutritionLabelPromo from '../components/ProductNutritionLabelPromo/ProductNutritionLabelPromo';
import ProductNutritionLabelPromostyles from '../components/ProductNutritionLabelPromo/ProductNutritionLabelPromo.styles';
import PromoHero from '../components/PromoHero/PromoHero';
import PromoHerostyles from '../components/PromoHero/PromoHero.styles';
import RecipeDirectionDetails from '../components/RecipeDirectionDetails/RecipeDirectionDetails';
import RecipeDirectionDetailsstyles from '../components/RecipeDirectionDetails/RecipeDirectionDetails.styles';
import RecipeGrid from '../components/RecipeGrid/RecipeGrid';
import RecipeGridstyles from '../components/RecipeGrid/RecipeGrid.styles';
import RecipeIngredientsDetails from '../components/RecipeIngredientsDetails/RecipeIngredientsDetails';
import RecipeIngredientsDetailsstyles from '../components/RecipeIngredientsDetails/RecipeIngredientsDetails.styles';
import RecipeOverview from '../components/RecipeOverview/RecipeOverview';
import RecipeOverviewstyles from '../components/RecipeOverview/RecipeOverview.styles';
import RecipeOverviewDirect from '../components/RecipeOverview/RecipeOverviewDirect';
import RecommendRecipe from '../components/RecommendRecipe/RecommendRecipe';
import RecommendRecipestyles from '../components/RecommendRecipe/RecommendRecipe.styles';
import RelatedCarousel from '../components/RelatedCarousel/RelatedCarousel';
import RelatedCarouselstyles from '../components/RelatedCarousel/RelatedCarousel.styles';
import RelatedCarouselSlide from '../components/RelatedCarouselSlide/RelatedCarouselSlide';
import RelatedCarouselSlidestyles from '../components/RelatedCarouselSlide/RelatedCarouselSlide.styles';
import RelatedPagesPromo from '../components/RelatedPagesPromo/RelatedPagesPromo';
import RelatedPagesPromostyles from '../components/RelatedPagesPromo/RelatedPagesPromo.styles';
import ScrollingImagesPromo from '../components/ScrollingImagesPromo/ScrollingImagesPromo';
import ScrollingImagesPromostyles from '../components/ScrollingImagesPromo/ScrollingImagesPromo.styles';
import ScrollingImagesPromoSlide from '../components/ScrollingImagesPromoSlide/ScrollingImagesPromoSlide';
import ScrollingImagesPromoSlidestyles from '../components/ScrollingImagesPromoSlide/ScrollingImagesPromoSlide.styles';
import ScrollingVanityTextWithVideo from '../components/ScrollingVanityTextWithVideo/ScrollingVanityTextWithVideo';
import ScrollingVanityTextWithVideostyles from '../components/ScrollingVanityTextWithVideo/ScrollingVanityTextWithVideo.styles';
import SearchBox from '../components/SearchBox/SearchBox';
import SearchBoxstyles from '../components/SearchBox/SearchBox.styles';
import SideBySide from '../components/SideBySide/SideBySide';
import SideBySidestyles from '../components/SideBySide/SideBySide.styles';
import SideBySideLargeImage from '../components/SideBySideLargeImage/SideBySideLargeImage';
import SideBySideLargeImagestyles from '../components/SideBySideLargeImage/SideBySideLargeImage.styles';
import SideBySideRevealImage from '../components/SideBySideRevealImage/SideBySideRevealImage';
import SideBySideRevealImagestyles from '../components/SideBySideRevealImage/SideBySideRevealImage.styles';
import HandleSvg from '../components/SideBySideRevealImage/InlineSvg/HandleSvg';
import SiteSearchResults from '../components/SiteSearchResults/SiteSearchResults';
import SiteSearchResultsstyles from '../components/SiteSearchResults/SiteSearchResults.styles';
import SmallImageWithText from '../components/SmallImageWithText/SmallImageWithText';
import SmallImageWithTextstyles from '../components/SmallImageWithText/SmallImageWithText.styles';
import SocialShare from '../components/SocialShare/SocialShare';
import SocialSharestyles from '../components/SocialShare/SocialShare.styles';
import SocialVideo from '../components/SocialVideo/SocialVideo';
import SocialVideostyles from '../components/SocialVideo/SocialVideo.styles';
import VerticalLineDecorationSvg from '../components/SocialVideo/VerticalLineDecorationSvg';
import SocialVideoSlide from '../components/SocialVideoSlide/SocialVideoSlide';
import SocialVideoSlidestyles from '../components/SocialVideoSlide/SocialVideoSlide.styles';
import CirclePlayBtnSvg from '../components/SocialVideoSlide/SubTemplates/CirclePlayBtnSvg';
import NutritionLabelTableCA from '../components/Tables/CA/NutritionLabelTableCA';
import NutritionLabelTableCAstyles from '../components/Tables/CA/NutritionLabelTableCA.styles';
import NutritionLabelTableUS from '../components/Tables/US/NutritionLabelTableUS';
import NutritionLabelTableUSstyles from '../components/Tables/US/NutritionLabelTableUS.styles';
import TestimonialCarousel from '../components/TestimonialCarousel/TestimonialCarousel';
import TestimonialCarouselstyles from '../components/TestimonialCarousel/TestimonialCarousel.styles';
import TestimonialCarouselSlide from '../components/TestimonialCarouselSlide/TestimonialCarouselSlide';
import TestimonialCarouselSlidestyles from '../components/TestimonialCarouselSlide/TestimonialCarouselSlide.styles';
import Text from '../components/Text/Text';
import Textstyles from '../components/Text/Text.styles';
import AlchemerSurvey from '../components/Text/SubTemplates/AlchemerSurvey';
import AlchemerSurveystyles from '../components/Text/SubTemplates/AlchemerSurvey.styles';
import AlchemerSurveyOnPage from '../components/Text/SubTemplates/AlchemerSurveyOnPage';
import BeanGameComponent from '../components/Text/SubTemplates/BeanGameComponent';
import BeanGameComponentstyles from '../components/Text/SubTemplates/BeanGameComponent.styles';
import CenteredVideo from '../components/Text/SubTemplates/CenteredVideo';
import CenteredVideostyles from '../components/Text/SubTemplates/CenteredVideo.styles';
import CenteredVideoComponent from '../components/Text/SubTemplates/CenteredVideoComponent';
import CenteredVideoComponentstyles from '../components/Text/SubTemplates/CenteredVideoComponent.styles';
import NewsletterFormComponent from '../components/Text/SubTemplates/NewsletterFormComponent';
import OverTheTopSurvey from '../components/Text/SubTemplates/OverTheTopSurvey';
import OverTheTopSurveystyles from '../components/Text/SubTemplates/OverTheTopSurvey.styles';
import SampleRequestForm from '../components/Text/SubTemplates/SampleRequestForm';
import SampleRequestFormstyles from '../components/Text/SubTemplates/SampleRequestForm.styles';
import SocialMediaComponent from '../components/Text/SubTemplates/SocialMediaComponent';
import SocialMediaComponentstyles from '../components/Text/SubTemplates/SocialMediaComponent.styles';
import UpdBeanGameComponent from '../components/Text/SubTemplates/UpdBeanGameComponent';
import VideoPlayer from '../components/Text/SubTemplates/VideoPlayer';
import VideoRightComponent from '../components/Text/SubTemplates/VideoRightComponent';
import VideoRightComponentstyles from '../components/Text/SubTemplates/VideoRightComponent.styles';
import VideoTimelineComponent from '../components/Text/SubTemplates/VideoTimelineComponent';
import VideoTimelineComponentstyles from '../components/Text/SubTemplates/VideoTimelineComponent.styles';
import VideoTimelineYoutubePlayer from '../components/Text/SubTemplates/VideoTimelineYoutubePlayer';
import BeanAndBurst from '../components/Text/SubTemplates/InlineSvg/BeanAndBurst';
import DukeBlueBean from '../components/Text/SubTemplates/InlineSvg/DukeBlueBean';
import DukeInBeanSvg from '../components/Text/SubTemplates/InlineSvg/DukeInBeanSvg';
import DukeInBeanSvgstyles from '../components/Text/SubTemplates/InlineSvg/DukeInBeanSvg.styles';
import DukeTalkBubbleSmallSvg from '../components/Text/SubTemplates/InlineSvg/DukeTalkBubbleSmallSvg';
import DukeTalkBubbleSvg from '../components/Text/SubTemplates/InlineSvg/DukeTalkBubbleSvg';
import JayDukeSecretFamilyRecipeSvg from '../components/Text/SubTemplates/InlineSvg/JayDukeSecretFamilyRecipeSvg';
import JayDukeSecretFamilyRecipeSvgstyle from '../components/Text/SubTemplates/InlineSvg/JayDukeSecretFamilyRecipeSvg.style';
import NineteenNfourSvg from '../components/Text/SubTemplates/InlineSvg/NineteenNfourSvg';
import NineteenNfourSvgstyles from '../components/Text/SubTemplates/InlineSvg/NineteenNfourSvg.styles';
import PlayBtnSvg from '../components/Text/SubTemplates/InlineSvg/PlayBtnSvg';
import PlayCutOutSvg from '../components/Text/SubTemplates/InlineSvg/PlayCutOutSvg';
import SoDarnGoodBBLogoSvg from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodBBLogoSvg';
import SoDarnGoodBBLogoSvgstyles from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodBBLogoSvg.styles';
import SoDarnGoodCSvg from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCSvg';
import SoDarnGoodCSvgstyles from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCSvg.styles';
import SoDarnGoodCirclePlateSvg from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodCirclePlateSvg';
import SoDarnGoodESvg from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodESvg';
import SoDarnGoodESvgstyles from '../components/Text/SubTemplates/InlineSvg/SoDarnGoodESvg.styles';
import ThirtyKSvg from '../components/Text/SubTemplates/InlineSvg/ThirtyKSvg';
import ThirtyKSvgstyles from '../components/Text/SubTemplates/InlineSvg/ThirtyKSvg.styles';
import TextLeftVideoRight from '../components/TextLeftVideoRight/TextLeftVideoRight';
import TextLeftVideoRightstyles from '../components/TextLeftVideoRight/TextLeftVideoRight.styles';
import ThirtyYearsSvg from '../components/ThirtyYearsSvg/ThirtyYearsSvg';
import ThirtyYearsSvgstyles from '../components/ThirtyYearsSvg/ThirtyYearsSvg.styles';
import ThreeColShowcase from '../components/ThreeColShowcase/ThreeColShowcase';
import ThreeColShowcasestyles from '../components/ThreeColShowcase/ThreeColShowcase.styles';
import TvVideoFrame from '../components/TvVideoFrame/TvVideoFrame';
import TvVideoFramestyles from '../components/TvVideoFrame/TvVideoFrame.styles';
import UtilityNav from '../components/UtilityNav/UtilityNav';
import VendorForm from '../components/VendorForm/VendorForm';
import VendorFormstyles from '../components/VendorForm/VendorForm.styles';
import VerticalEmbeds from '../components/VerticalEmbeds/VerticalEmbeds';
import VerticalEmbedsstyles from '../components/VerticalEmbeds/VerticalEmbeds.styles';
import CircularPlayBtnSvg from '../components/VerticalEmbeds/SubTemplates/CircularPlayBtnSvg';
import YoutubePlayerWindow from '../components/VerticalEmbeds/SubTemplates/YoutubePlayerWindow';
import StyleguideFieldUsageCheckbox from '../components/fields/Styleguide-FieldUsage-Checkbox';
import StyleguideFieldUsageContentList from '../components/fields/Styleguide-FieldUsage-ContentList';
import StyleguideFieldUsageCustom from '../components/fields/Styleguide-FieldUsage-Custom';
import StyleguideFieldUsageDate from '../components/fields/Styleguide-FieldUsage-Date';
import StyleguideFieldUsageFile from '../components/fields/Styleguide-FieldUsage-File';
import StyleguideFieldUsageImage from '../components/fields/Styleguide-FieldUsage-Image';
import StyleguideFieldUsageItemLink from '../components/fields/Styleguide-FieldUsage-ItemLink';
import StyleguideFieldUsageLink from '../components/fields/Styleguide-FieldUsage-Link';
import StyleguideFieldUsageNumber from '../components/fields/Styleguide-FieldUsage-Number';
import StyleguideFieldUsageRichText from '../components/fields/Styleguide-FieldUsage-RichText';
import StyleguideFieldUsageText from '../components/fields/Styleguide-FieldUsage-Text';
import GraphQLConnectedDemo from '../components/graphql/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/graphql/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/graphql/GraphQL-Layout';
import JssOverridesRichText from '../components/shared/JssOverridesRichText';
import JssOverridesText from '../components/shared/JssOverridesText';
import LoadingIcon from '../components/shared/LoadingIcon';
import Separator from '../components/shared/Separator';
import Button from '../components/shared/Button/Button';
import Buttonstyles from '../components/shared/Button/Button.styles';
import ButtonTypes from '../components/shared/Button/ButtonTypes';
import Card from '../components/shared/Card/Card';
import Cardstyles from '../components/shared/Card/Card.styles';
import CardTypes from '../components/shared/Card/CardTypes/CardTypes';
import CardTypesstyles from '../components/shared/Card/CardTypes/CardTypes.styles';
import ArticleCard from '../components/shared/Card/CardTypes/article/ArticleCard';
import CardTypeContentCard from '../components/shared/Card/CardTypes/content/CardTypeContentCard';
import FeaturedCard from '../components/shared/Card/CardTypes/featured/FeaturedCard';
import PageCard from '../components/shared/Card/CardTypes/page/PageCard';
import ProductCard from '../components/shared/Card/CardTypes/product/ProductCard';
import ProductPromoCard from '../components/shared/Card/CardTypes/product/ProductPromoCard';
import RecipeCard from '../components/shared/Card/CardTypes/recipe/RecipeCard';
import RecipePromoCard from '../components/shared/Card/CardTypes/recipe/RecipePromoCard';
import RelatedCard from '../components/shared/Card/CardTypes/related/RelatedCard';
import CardFs from '../components/shared/CardFs/CardFs';
import CardFsstyles from '../components/shared/CardFs/CardFs.styles';
import CardTypesFs from '../components/shared/CardFs/CardTypes/CardTypesFs';
import CardTypesFsstyles from '../components/shared/CardFs/CardTypes/CardTypesFs.styles';
import ArticleCardFs from '../components/shared/CardFs/CardTypes/article/ArticleCardFs';
import ContentCardFs from '../components/shared/CardFs/CardTypes/content/ContentCardFs';
import PageCardFs from '../components/shared/CardFs/CardTypes/page/PageCardFs';
import ProductCardFs from '../components/shared/CardFs/CardTypes/product/ProductCardFs';
import ProductPromoCardFs from '../components/shared/CardFs/CardTypes/product/ProductPromoCardFs';
import RecipeCardFs from '../components/shared/CardFs/CardTypes/recipe/RecipeCardFs';
import RecipePromoCardFs from '../components/shared/CardFs/CardTypes/recipe/RecipePromoCardFs';
import RelatedCardFs from '../components/shared/CardFs/CardTypes/related/RelatedCardFs';
import Carousel from '../components/shared/Carousel/Carousel';
import Carouselstyles from '../components/shared/Carousel/Carousel.styles';
import FeaturedProduct from '../components/shared/FeaturedProduct/FeaturedProduct';
import FeaturedProductstyles from '../components/shared/FeaturedProduct/FeaturedProduct.styles';
import Grid from '../components/shared/Grid/Grid';
import Gridstyle from '../components/shared/Grid/Grid.style';
import GridFs from '../components/shared/GridFs/GridFs';
import GridFsstyle from '../components/shared/GridFs/GridFs.style';
import Icon from '../components/shared/Icon/Icon';
import Iconstyles from '../components/shared/Icon/Icon.styles';
import Input from '../components/shared/Input/Input';
import Inputstyles from '../components/shared/Input/Input.styles';
import BeanCheck from '../components/shared/Input/components/BeanCheck';
import Checkbox from '../components/shared/Input/components/Checkbox';
import Radio from '../components/shared/Input/components/Radio';
import TextInput from '../components/shared/Input/components/TextInput';
import InterruptorRibbon from '../components/shared/InterruptorRibbon/InterruptorRibbon';
import InterruptorRibbonstyles from '../components/shared/InterruptorRibbon/InterruptorRibbon.styles';
import Link from '../components/shared/Link/Link';
import Listing from '../components/shared/Listing/Listing';
import Listingstyles from '../components/shared/Listing/Listing.styles';
import ListingError from '../components/shared/Listing/components/Error/ListingError';
import FilterFooter from '../components/shared/Listing/components/Filters/FilterFooter';
import FilterHeader from '../components/shared/Listing/components/Filters/FilterHeader';
import FilterOptions from '../components/shared/Listing/components/Filters/FilterOptions';
import Filtersconfig from '../components/shared/Listing/components/Filters/Filters.config';
import Filtersstyles from '../components/shared/Listing/components/Filters/Filters.styles';
import ListingFilters from '../components/shared/Listing/components/Filters/ListingFilters';
import NoResults from '../components/shared/Listing/components/Results/NoResults';
import Results from '../components/shared/Listing/components/Results/Results';
import Resultsstyles from '../components/shared/Listing/components/Results/Results.styles';
import SVGspiral from '../components/shared/Listing/components/svg/SVGspiral';
import SvgSpiralstyles from '../components/shared/Listing/components/svg/SvgSpiral.styles';
import ListingFs from '../components/shared/ListingFs/ListingFs';
import ListingFsstyles from '../components/shared/ListingFs/ListingFs.styles';
import ListingErrorFs from '../components/shared/ListingFs/componentsFs/ErrorFs/ListingErrorFs';
import FilterFooterFs from '../components/shared/ListingFs/componentsFs/FiltersFs/FilterFooterFs';
import FilterHeaderFs from '../components/shared/ListingFs/componentsFs/FiltersFs/FilterHeaderFs';
import FilterOptionsFs from '../components/shared/ListingFs/componentsFs/FiltersFs/FilterOptionsFs';
import FiltersFsconfig from '../components/shared/ListingFs/componentsFs/FiltersFs/FiltersFs.config';
import FiltersFsstyles from '../components/shared/ListingFs/componentsFs/FiltersFs/FiltersFs.styles';
import ListingFiltersFs from '../components/shared/ListingFs/componentsFs/FiltersFs/ListingFiltersFs';
import NoResultsFs from '../components/shared/ListingFs/componentsFs/ResultsFs/NoResultsFs';
import ResultsFs from '../components/shared/ListingFs/componentsFs/ResultsFs/ResultsFs';
import ResultsFsstyles from '../components/shared/ListingFs/componentsFs/ResultsFs/ResultsFs.styles';
import LoadingSpinner from '../components/shared/LoadingSpinner/LoadingSpinner';
import LoadingSpinnerstyles from '../components/shared/LoadingSpinner/LoadingSpinner.styles';
import Modal from '../components/shared/Modal/Modal';
import Modalstyle from '../components/shared/Modal/Modal.style';
import NutritionTable from '../components/shared/NutritionTable/NutritionTable';
import NutritionTablestyles from '../components/shared/NutritionTable/NutritionTable.styles';
import Overlay from '../components/shared/Overlay/Overlay';
import Overlaystyles from '../components/shared/Overlay/Overlay.styles';
import PromoBox from '../components/shared/PromoBox/PromoBox';
import PromoBoxstyles from '../components/shared/PromoBox/PromoBox.styles';
import RecipeWrapper from '../components/shared/RecipeWrapper/RecipeWrapper';
import RecipeWrapperstyles from '../components/shared/RecipeWrapper/RecipeWrapper.styles';
import Ribbon from '../components/shared/Ribbon/Ribbon';
import Ribbonstyles from '../components/shared/Ribbon/Ribbon.styles';
import ScrollingText from '../components/shared/ScrollingText/ScrollingText';
import ScrollingTextstyles from '../components/shared/ScrollingText/ScrollingText.styles';
import SearchResultComponent from '../components/shared/SearchResultComponent/SearchResultComponent';
import SearchResultComponentstyles from '../components/shared/SearchResultComponent/SearchResultComponent.styles';
import Select from '../components/shared/Select/Select';
import Selectstyles from '../components/shared/Select/Select.styles';
import SocialLinks from '../components/shared/SocialLinks/SocialLinks';
import SocialLinksstyles from '../components/shared/SocialLinks/SocialLinks.styles';
import Subscribe from '../components/shared/Subscribe/Subscribe';
import Subscribestyle from '../components/shared/Subscribe/Subscribe.style';
import Textarea from '../components/shared/Textarea/Textarea';
import Textareastyles from '../components/shared/Textarea/Textarea.styles';
import Tooltip from '../components/shared/Tooltip/Tooltip';
import Tooltipstyles from '../components/shared/Tooltip/Tooltip.styles';
import Video from '../components/shared/Video/Video';
import Videostyles from '../components/shared/Video/Video.styles';
import SVGspiralImg from '../components/shared/Video/InlineSvg/SVGspiralImg';
import SvgSpiralImgstyles from '../components/shared/Video/InlineSvg/SvgSpiralImg.styles';
import VideoPlayBtn from '../components/shared/Video/InlineSvg/VideoPlayBtn';
import StyleguideComponentParams from '../components/styleguide/Styleguide-ComponentParams';
import StyleguideCustomRouteType from '../components/styleguide/Styleguide-CustomRouteType';
import StyleguideEditFrame from '../components/styleguide/Styleguide-EditFrame';
import StyleguideLayoutReuse from '../components/styleguide/Styleguide-Layout-Reuse';
import StyleguideLayoutTabsTab from '../components/styleguide/Styleguide-Layout-Tabs-Tab';
import StyleguideLayoutTabs from '../components/styleguide/Styleguide-Layout-Tabs';
import StyleguideLayout from '../components/styleguide/Styleguide-Layout';
import StyleguideMultilingual from '../components/styleguide/Styleguide-Multilingual';
import StyleguideRouteFields from '../components/styleguide/Styleguide-RouteFields';
import StyleguideSection from '../components/styleguide/Styleguide-Section';
import StyleguideSitecoreContext from '../components/styleguide/Styleguide-SitecoreContext';
import StyleguideSpecimen from '../components/styleguide/Styleguide-Specimen';
import StyleguideTracking from '../components/styleguide/Styleguide-Tracking';
import DownloadSvg from '../components/svg/DownloadSvg';
import ShareIconSvg from '../components/svg/ShareIconSvg';

const components = new Map();

components.set('NutritionLabelTable', NutritionLabelTable);
components.set('TestComponent', TestComponent);
components.set('YoutubePlayer', YoutubePlayer);
components.set('Accordion', Accordion);
components.set('Accordion.styles', Accordionstyles);
components.set('AccordionSection', AccordionSection);
components.set('AccordionSection.styles', AccordionSectionstyles);
components.set('AlertRibbon', AlertRibbon);
components.set('AlertRibbon.styles', AlertRibbonstyles);
components.set('ArticleGrid', ArticleGrid);
components.set('ArticleGrid.styles', ArticleGridstyles);
components.set('BeautifulBeanFootageTVSvg', BeautifulBeanFootageTVSvg);
components.set('BeautifulBeanFootageTVSvg.styles', BeautifulBeanFootageTVSvgstyles);
components.set('BlogAccordion', BlogAccordion);
components.set('BlogAccordion.styles', BlogAccordionstyles);
components.set('BlogAccordionSection', BlogAccordionSection);
components.set('BlogAccordionSection.styles', BlogAccordionSectionstyles);
components.set('BlueyBeanChallenge', BlueyBeanChallenge);
components.set('BlueyBeanChallenge.styles', BlueyBeanChallengestyles);
components.set('CallToAction', CallToAction);
components.set('CallToAction.styles', CallToActionstyles);
components.set('CenteredTextVideo', CenteredTextVideo);
components.set('CenteredTextVideo.styles', CenteredTextVideostyles);
components.set('ContactRepForm', ContactRepForm);
components.set('ContactRepForm.styles', ContactRepFormstyles);
components.set('ContactRepHero', ContactRepHero);
components.set('ContactUsForm', ContactUsForm);
components.set('ContactUsForm.styles', ContactUsFormstyles);
components.set('ContactUsHero', ContactUsHero);
components.set('Content', Content);
components.set('Content.styles', Contentstyles);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlock.styles', ContentBlockstyles);
components.set('ContentCard', ContentCard);
components.set('ContentCard.styles', ContentCardstyles);
components.set('ContentCardContainer', ContentCardContainer);
components.set('ContentCardContainer.styles', ContentCardContainerstyles);
components.set('CookiePolicy', CookiePolicy);
components.set('CookiePolicy.styles', CookiePolicystyles);
components.set('FavoritesGrid', FavoritesGrid);
components.set('FavoritesGrid.styles', FavoritesGridstyles);
components.set('FeaturedDetailHero', FeaturedDetailHero);
components.set('FeaturedDetailHero.styles', FeaturedDetailHerostyles);
components.set('ArticlePromo', ArticlePromo);
components.set('ArticlePromo.styles', ArticlePromostyles);
components.set('GeneralPromo', GeneralPromo);
components.set('GeneralPromo.styles', GeneralPromostyles);
components.set('RecipePromo', RecipePromo);
components.set('RecipePromo.styles', RecipePromostyles);
components.set('FeaturedDetailHeroWithVideo', FeaturedDetailHeroWithVideo);
components.set('FeaturedDetailHeroWithVideo.styles', FeaturedDetailHeroWithVideostyles);
components.set('FeaturedFacts', FeaturedFacts);
components.set('FeaturedFacts.styles', FeaturedFactsstyles);
components.set('FeaturedRecipePromo', FeaturedRecipePromo);
components.set('FeaturedRecipePromo.styles', FeaturedRecipePromostyles);
components.set('FindInStoreSearchDestiny', FindInStoreSearchDestiny);
components.set('FindInStoreSearchDestiny.styles', FindInStoreSearchDestinystyles);
components.set('FindNearYou', FindNearYou);
components.set('FindNearYou.styles', FindNearYoustyles);
components.set('Footer', Footer);
components.set('Footer.styles', Footerstyles);
components.set('SubscribeLoader', SubscribeLoader);
components.set('LinksList', LinksList);
components.set('HeroCarousel', HeroCarousel);
components.set('HeroCarousel.styles', HeroCarouselstyles);
components.set('HeroCarouselSlide', HeroCarouselSlide);
components.set('HeroCarouselSlide.styles', HeroCarouselSlidestyles);
components.set('HeroWithTextLeft', HeroWithTextLeft);
components.set('HeroWithTextLeft.styles', HeroWithTextLeftstyles);
components.set('clouds', clouds);
components.set('HomepageHeroCarousel', HomepageHeroCarousel);
components.set('HomepageHeroCarousel.styles', HomepageHeroCarouselstyles);
components.set('HomepageHeroCarouselSlide', HomepageHeroCarouselSlide);
components.set('HomepageHeroCarouselSlide.styles', HomepageHeroCarouselSlidestyles);
components.set('IconButton', IconButton);
components.set('IconButton.styles', IconButtonstyles);
components.set('IconList', IconList);
components.set('IconList.styles', IconListstyles);
components.set('IconListItem', IconListItem);
components.set('ImageSlider', ImageSlider);
components.set('ImageSlider.styles', ImageSliderstyles);
components.set('ImageSliderSlide', ImageSliderSlide);
components.set('ImageSliderSlide.styles', ImageSliderSlidestyles);
components.set('InRecipeProductsFoodservices', InRecipeProductsFoodservices);
components.set('InRecipeProductsFoodservices.styles', InRecipeProductsFoodservicesstyles);
components.set('InRecipeProductsPromo', InRecipeProductsPromo);
components.set('InRecipeProductsPromo.styles', InRecipeProductsPromostyles);
components.set('LandingHero', LandingHero);
components.set('LandingHero.styles', LandingHerostyles);
components.set('LazyImage', LazyImage);
components.set('MainNav', MainNav);
components.set('MainNav.styles', MainNavstyles);
components.set('DesktopNav', DesktopNav);
components.set('DesktopNav.styles', DesktopNavstyles);
components.set('FsDesktopNav', FsDesktopNav);
components.set('FsDesktopNav.styles', FsDesktopNavstyles);
components.set('FsHamburger', FsHamburger);
components.set('FsHamburger.styles', FsHamburgerstyles);
components.set('FsMainNavAboutUsLink', FsMainNavAboutUsLink);
components.set('FsMainNavAboutUsLink.styles', FsMainNavAboutUsLinkstyles);
components.set('FsMainNavCardLink', FsMainNavCardLink);
components.set('FsMainNavCardLink.styles', FsMainNavCardLinkstyles);
components.set('FsMainNavProductLink', FsMainNavProductLink);
components.set('FsMainNavProductLink.styles', FsMainNavProductLinkstyles);
components.set('FsMobileNav', FsMobileNav);
components.set('FsMobileNav.styles', FsMobileNavstyles);
components.set('Hamburger', Hamburger);
components.set('Hamburger.styles', Hamburgerstyles);
components.set('MainNavAboutUsLink', MainNavAboutUsLink);
components.set('MainNavAboutUsLink.styles', MainNavAboutUsLinkstyles);
components.set('MainNavProductLink', MainNavProductLink);
components.set('MainNavProductLink.styles', MainNavProductLinkstyles);
components.set('MainNavRibbon', MainNavRibbon);
components.set('MainNavRibbon.styles', MainNavRibbonstyles);
components.set('MainNavRibbonCta', MainNavRibbonCta);
components.set('MainNavRibbonCta.styles', MainNavRibbonCtastyles);
components.set('MobileNav', MobileNav);
components.set('MobileNav.styles', MobileNavstyles);
components.set('MediaCarousel', MediaCarousel);
components.set('MediaCarousel.styles', MediaCarouselstyles);
components.set('MediaCarouselImageSlide', MediaCarouselImageSlide);
components.set('MediaCarouselImageSlide.styles', MediaCarouselImageSlidestyles);
components.set('MediaCarouselVideoSlide', MediaCarouselVideoSlide);
components.set('MediaCarouselVideoSlide.styles', MediaCarouselVideoSlidestyles);
components.set('NavLink', NavLink);
components.set('NavLink.styles', NavLinkstyles);
components.set('NotFound', NotFound);
components.set('NotFound.styles', NotFoundstyles);
components.set('OffsetFeaturePromo', OffsetFeaturePromo);
components.set('OffsetFeaturePromo.styles', OffsetFeaturePromostyles);
components.set('OverTheTopSurveyEmbed', OverTheTopSurveyEmbed);
components.set('OverTheTopSurveyEmbed.styles', OverTheTopSurveyEmbedstyles);
components.set('ProductCTA', ProductCTA);
components.set('ProductCTA.styles', ProductCTAstyles);
components.set('ProductDescription', ProductDescription);
components.set('ProductDescription.styles', ProductDescriptionstyles);
components.set('ProductDetailHero', ProductDetailHero);
components.set('ProductDetailHero.styles', ProductDetailHerostyles);
components.set('ProductGrid', ProductGrid);
components.set('ProductGrid.styles', ProductGridstyles);
components.set('ProductIngredientBenefitsPromo.config', ProductIngredientBenefitsPromoconfig);
components.set('ProductIngredientBenefitsPromo', ProductIngredientBenefitsPromo);
components.set('ProductIngredientBenefitsPromo.styles', ProductIngredientBenefitsPromostyles);
components.set('ProductListCarousel', ProductListCarousel);
components.set('ProductListCarousel.styles', ProductListCarouselstyles);
components.set('ProductNutritionLabelPromo', ProductNutritionLabelPromo);
components.set('ProductNutritionLabelPromo.styles', ProductNutritionLabelPromostyles);
components.set('PromoHero', PromoHero);
components.set('PromoHero.styles', PromoHerostyles);
components.set('RecipeDirectionDetails', RecipeDirectionDetails);
components.set('RecipeDirectionDetails.styles', RecipeDirectionDetailsstyles);
components.set('RecipeGrid', RecipeGrid);
components.set('RecipeGrid.styles', RecipeGridstyles);
components.set('RecipeIngredientsDetails', RecipeIngredientsDetails);
components.set('RecipeIngredientsDetails.styles', RecipeIngredientsDetailsstyles);
components.set('RecipeOverview', RecipeOverview);
components.set('RecipeOverview.styles', RecipeOverviewstyles);
components.set('RecipeOverviewDirect', RecipeOverviewDirect);
components.set('RecommendRecipe', RecommendRecipe);
components.set('RecommendRecipe.styles', RecommendRecipestyles);
components.set('RelatedCarousel', RelatedCarousel);
components.set('RelatedCarousel.styles', RelatedCarouselstyles);
components.set('RelatedCarouselSlide', RelatedCarouselSlide);
components.set('RelatedCarouselSlide.styles', RelatedCarouselSlidestyles);
components.set('RelatedPagesPromo', RelatedPagesPromo);
components.set('RelatedPagesPromo.styles', RelatedPagesPromostyles);
components.set('ScrollingImagesPromo', ScrollingImagesPromo);
components.set('ScrollingImagesPromo.styles', ScrollingImagesPromostyles);
components.set('ScrollingImagesPromoSlide', ScrollingImagesPromoSlide);
components.set('ScrollingImagesPromoSlide.styles', ScrollingImagesPromoSlidestyles);
components.set('ScrollingVanityTextWithVideo', ScrollingVanityTextWithVideo);
components.set('ScrollingVanityTextWithVideo.styles', ScrollingVanityTextWithVideostyles);
components.set('SearchBox', SearchBox);
components.set('SearchBox.styles', SearchBoxstyles);
components.set('SideBySide', SideBySide);
components.set('SideBySide.styles', SideBySidestyles);
components.set('SideBySideLargeImage', SideBySideLargeImage);
components.set('SideBySideLargeImage.styles', SideBySideLargeImagestyles);
components.set('SideBySideRevealImage', SideBySideRevealImage);
components.set('SideBySideRevealImage.styles', SideBySideRevealImagestyles);
components.set('HandleSvg', HandleSvg);
components.set('SiteSearchResults', SiteSearchResults);
components.set('SiteSearchResults.styles', SiteSearchResultsstyles);
components.set('SmallImageWithText', SmallImageWithText);
components.set('SmallImageWithText.styles', SmallImageWithTextstyles);
components.set('SocialShare', SocialShare);
components.set('SocialShare.styles', SocialSharestyles);
components.set('SocialVideo', SocialVideo);
components.set('SocialVideo.styles', SocialVideostyles);
components.set('VerticalLineDecorationSvg', VerticalLineDecorationSvg);
components.set('SocialVideoSlide', SocialVideoSlide);
components.set('SocialVideoSlide.styles', SocialVideoSlidestyles);
components.set('CirclePlayBtnSvg', CirclePlayBtnSvg);
components.set('NutritionLabelTableCA', NutritionLabelTableCA);
components.set('NutritionLabelTableCA.styles', NutritionLabelTableCAstyles);
components.set('NutritionLabelTableUS', NutritionLabelTableUS);
components.set('NutritionLabelTableUS.styles', NutritionLabelTableUSstyles);
components.set('TestimonialCarousel', TestimonialCarousel);
components.set('TestimonialCarousel.styles', TestimonialCarouselstyles);
components.set('TestimonialCarouselSlide', TestimonialCarouselSlide);
components.set('TestimonialCarouselSlide.styles', TestimonialCarouselSlidestyles);
components.set('Text', Text);
components.set('Text.styles', Textstyles);
components.set('AlchemerSurvey', AlchemerSurvey);
components.set('AlchemerSurvey.styles', AlchemerSurveystyles);
components.set('AlchemerSurveyOnPage', AlchemerSurveyOnPage);
components.set('BeanGameComponent', BeanGameComponent);
components.set('BeanGameComponent.styles', BeanGameComponentstyles);
components.set('CenteredVideo', CenteredVideo);
components.set('CenteredVideo.styles', CenteredVideostyles);
components.set('CenteredVideoComponent', CenteredVideoComponent);
components.set('CenteredVideoComponent.styles', CenteredVideoComponentstyles);
components.set('NewsletterFormComponent', NewsletterFormComponent);
components.set('OverTheTopSurvey', OverTheTopSurvey);
components.set('OverTheTopSurvey.styles', OverTheTopSurveystyles);
components.set('SampleRequestForm', SampleRequestForm);
components.set('SampleRequestForm.styles', SampleRequestFormstyles);
components.set('SocialMediaComponent', SocialMediaComponent);
components.set('SocialMediaComponent.styles', SocialMediaComponentstyles);
components.set('UpdBeanGameComponent', UpdBeanGameComponent);
components.set('VideoPlayer', VideoPlayer);
components.set('VideoRightComponent', VideoRightComponent);
components.set('VideoRightComponent.styles', VideoRightComponentstyles);
components.set('VideoTimelineComponent', VideoTimelineComponent);
components.set('VideoTimelineComponent.styles', VideoTimelineComponentstyles);
components.set('VideoTimelineYoutubePlayer', VideoTimelineYoutubePlayer);
components.set('BeanAndBurst', BeanAndBurst);
components.set('DukeBlueBean', DukeBlueBean);
components.set('DukeInBeanSvg', DukeInBeanSvg);
components.set('DukeInBeanSvg.styles', DukeInBeanSvgstyles);
components.set('DukeTalkBubbleSmallSvg', DukeTalkBubbleSmallSvg);
components.set('DukeTalkBubbleSvg', DukeTalkBubbleSvg);
components.set('JayDukeSecretFamilyRecipeSvg', JayDukeSecretFamilyRecipeSvg);
components.set('JayDukeSecretFamilyRecipeSvg.style', JayDukeSecretFamilyRecipeSvgstyle);
components.set('NineteenNfourSvg', NineteenNfourSvg);
components.set('NineteenNfourSvg.styles', NineteenNfourSvgstyles);
components.set('PlayBtnSvg', PlayBtnSvg);
components.set('PlayCutOutSvg', PlayCutOutSvg);
components.set('SoDarnGoodBBLogoSvg', SoDarnGoodBBLogoSvg);
components.set('SoDarnGoodBBLogoSvg.styles', SoDarnGoodBBLogoSvgstyles);
components.set('SoDarnGoodCSvg', SoDarnGoodCSvg);
components.set('SoDarnGoodCSvg.styles', SoDarnGoodCSvgstyles);
components.set('SoDarnGoodCirclePlateSvg', SoDarnGoodCirclePlateSvg);
components.set('SoDarnGoodESvg', SoDarnGoodESvg);
components.set('SoDarnGoodESvg.styles', SoDarnGoodESvgstyles);
components.set('ThirtyKSvg', ThirtyKSvg);
components.set('ThirtyKSvg.styles', ThirtyKSvgstyles);
components.set('TextLeftVideoRight', TextLeftVideoRight);
components.set('TextLeftVideoRight.styles', TextLeftVideoRightstyles);
components.set('ThirtyYearsSvg', ThirtyYearsSvg);
components.set('ThirtyYearsSvg.styles', ThirtyYearsSvgstyles);
components.set('ThreeColShowcase', ThreeColShowcase);
components.set('ThreeColShowcase.styles', ThreeColShowcasestyles);
components.set('TvVideoFrame', TvVideoFrame);
components.set('TvVideoFrame.styles', TvVideoFramestyles);
components.set('UtilityNav', UtilityNav);
components.set('VendorForm', VendorForm);
components.set('VendorForm.styles', VendorFormstyles);
components.set('VerticalEmbeds', VerticalEmbeds);
components.set('VerticalEmbeds.styles', VerticalEmbedsstyles);
components.set('CircularPlayBtnSvg', CircularPlayBtnSvg);
components.set('YoutubePlayerWindow', YoutubePlayerWindow);
components.set('Styleguide-FieldUsage-Checkbox', StyleguideFieldUsageCheckbox);
components.set('Styleguide-FieldUsage-ContentList', StyleguideFieldUsageContentList);
components.set('Styleguide-FieldUsage-Custom', StyleguideFieldUsageCustom);
components.set('Styleguide-FieldUsage-Date', StyleguideFieldUsageDate);
components.set('Styleguide-FieldUsage-File', StyleguideFieldUsageFile);
components.set('Styleguide-FieldUsage-Image', StyleguideFieldUsageImage);
components.set('Styleguide-FieldUsage-ItemLink', StyleguideFieldUsageItemLink);
components.set('Styleguide-FieldUsage-Link', StyleguideFieldUsageLink);
components.set('Styleguide-FieldUsage-Number', StyleguideFieldUsageNumber);
components.set('Styleguide-FieldUsage-RichText', StyleguideFieldUsageRichText);
components.set('Styleguide-FieldUsage-Text', StyleguideFieldUsageText);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('JssOverridesRichText', JssOverridesRichText);
components.set('JssOverridesText', JssOverridesText);
components.set('LoadingIcon', LoadingIcon);
components.set('Separator', Separator);
components.set('Button', Button);
components.set('Button.styles', Buttonstyles);
components.set('ButtonTypes', ButtonTypes);
components.set('Card', Card);
components.set('Card.styles', Cardstyles);
components.set('CardTypes', CardTypes);
components.set('CardTypes.styles', CardTypesstyles);
components.set('ArticleCard', ArticleCard);
components.set('CardTypeContentCard', CardTypeContentCard);
components.set('FeaturedCard', FeaturedCard);
components.set('PageCard', PageCard);
components.set('ProductCard', ProductCard);
components.set('ProductPromoCard', ProductPromoCard);
components.set('RecipeCard', RecipeCard);
components.set('RecipePromoCard', RecipePromoCard);
components.set('RelatedCard', RelatedCard);
components.set('CardFs', CardFs);
components.set('CardFs.styles', CardFsstyles);
components.set('CardTypesFs', CardTypesFs);
components.set('CardTypesFs.styles', CardTypesFsstyles);
components.set('ArticleCardFs', ArticleCardFs);
components.set('ContentCardFs', ContentCardFs);
components.set('PageCardFs', PageCardFs);
components.set('ProductCardFs', ProductCardFs);
components.set('ProductPromoCardFs', ProductPromoCardFs);
components.set('RecipeCardFs', RecipeCardFs);
components.set('RecipePromoCardFs', RecipePromoCardFs);
components.set('RelatedCardFs', RelatedCardFs);
components.set('Carousel', Carousel);
components.set('Carousel.styles', Carouselstyles);
components.set('FeaturedProduct', FeaturedProduct);
components.set('FeaturedProduct.styles', FeaturedProductstyles);
components.set('Grid', Grid);
components.set('Grid.style', Gridstyle);
components.set('GridFs', GridFs);
components.set('GridFs.style', GridFsstyle);
components.set('Icon', Icon);
components.set('Icon.styles', Iconstyles);
components.set('Input', Input);
components.set('Input.styles', Inputstyles);
components.set('BeanCheck', BeanCheck);
components.set('Checkbox', Checkbox);
components.set('Radio', Radio);
components.set('TextInput', TextInput);
components.set('InterruptorRibbon', InterruptorRibbon);
components.set('InterruptorRibbon.styles', InterruptorRibbonstyles);
components.set('Link', Link);
components.set('Listing', Listing);
components.set('Listing.styles', Listingstyles);
components.set('ListingError', ListingError);
components.set('FilterFooter', FilterFooter);
components.set('FilterHeader', FilterHeader);
components.set('FilterOptions', FilterOptions);
components.set('Filters.config', Filtersconfig);
components.set('Filters.styles', Filtersstyles);
components.set('ListingFilters', ListingFilters);
components.set('NoResults', NoResults);
components.set('Results', Results);
components.set('Results.styles', Resultsstyles);
components.set('SVGspiral', SVGspiral);
components.set('SvgSpiral.styles', SvgSpiralstyles);
components.set('ListingFs', ListingFs);
components.set('ListingFs.styles', ListingFsstyles);
components.set('ListingErrorFs', ListingErrorFs);
components.set('FilterFooterFs', FilterFooterFs);
components.set('FilterHeaderFs', FilterHeaderFs);
components.set('FilterOptionsFs', FilterOptionsFs);
components.set('FiltersFs.config', FiltersFsconfig);
components.set('FiltersFs.styles', FiltersFsstyles);
components.set('ListingFiltersFs', ListingFiltersFs);
components.set('NoResultsFs', NoResultsFs);
components.set('ResultsFs', ResultsFs);
components.set('ResultsFs.styles', ResultsFsstyles);
components.set('LoadingSpinner', LoadingSpinner);
components.set('LoadingSpinner.styles', LoadingSpinnerstyles);
components.set('Modal', Modal);
components.set('Modal.style', Modalstyle);
components.set('NutritionTable', NutritionTable);
components.set('NutritionTable.styles', NutritionTablestyles);
components.set('Overlay', Overlay);
components.set('Overlay.styles', Overlaystyles);
components.set('PromoBox', PromoBox);
components.set('PromoBox.styles', PromoBoxstyles);
components.set('RecipeWrapper', RecipeWrapper);
components.set('RecipeWrapper.styles', RecipeWrapperstyles);
components.set('Ribbon', Ribbon);
components.set('Ribbon.styles', Ribbonstyles);
components.set('ScrollingText', ScrollingText);
components.set('ScrollingText.styles', ScrollingTextstyles);
components.set('SearchResultComponent', SearchResultComponent);
components.set('SearchResultComponent.styles', SearchResultComponentstyles);
components.set('Select', Select);
components.set('Select.styles', Selectstyles);
components.set('SocialLinks', SocialLinks);
components.set('SocialLinks.styles', SocialLinksstyles);
components.set('Subscribe', Subscribe);
components.set('Subscribe.style', Subscribestyle);
components.set('Textarea', Textarea);
components.set('Textarea.styles', Textareastyles);
components.set('Tooltip', Tooltip);
components.set('Tooltip.styles', Tooltipstyles);
components.set('Video', Video);
components.set('Video.styles', Videostyles);
components.set('SVGspiralImg', SVGspiralImg);
components.set('SvgSpiralImg.styles', SvgSpiralImgstyles);
components.set('VideoPlayBtn', VideoPlayBtn);
components.set('Styleguide-ComponentParams', StyleguideComponentParams);
components.set('Styleguide-CustomRouteType', StyleguideCustomRouteType);
components.set('Styleguide-EditFrame', StyleguideEditFrame);
components.set('Styleguide-Layout-Reuse', StyleguideLayoutReuse);
components.set('Styleguide-Layout-Tabs-Tab', StyleguideLayoutTabsTab);
components.set('Styleguide-Layout-Tabs', StyleguideLayoutTabs);
components.set('Styleguide-Layout', StyleguideLayout);
components.set('Styleguide-Multilingual', StyleguideMultilingual);
components.set('Styleguide-RouteFields', StyleguideRouteFields);
components.set('Styleguide-Section', StyleguideSection);
components.set('Styleguide-SitecoreContext', StyleguideSitecoreContext);
components.set('Styleguide-Specimen', StyleguideSpecimen);
components.set('Styleguide-Tracking', StyleguideTracking);
components.set('DownloadSvg', DownloadSvg);
components.set('ShareIconSvg', ShareIconSvg);

const componentBuilder = new ComponentBuilder({ components });

export const componentFactory = componentBuilder.getComponentFactory();
